/* istanbul ignore file */

import Honeybadger from 'lib/honeybadger';

function getUserId36() {
  const { USER, blGlobal } = window;
  if (USER) {
    return USER.id36;
  }

  if (blGlobal) {
    return blGlobal.user.id_36;
  }

  return '';
}

const userId = getUserId36();

export const notifyErrors = (label, errorObject, { context, params } = {}) => {
  const options = {
    name: 'midas',
    user_id: userId,
    params: {
      ...params,
    },
    context: {
      label,
      ...context,
    },
  };

  console.warn('Honeybadger.notify', { errorObject, options });
  if (process.env.NODE_ENV !== 'development') {
    Honeybadger.notify(errorObject, options);
  }
};

export default {
  notifyErrors,
};
